import styled from '@emotion/styled';
import { colors, typography } from '@/styles';

export const Title = styled.span`
    ${typography.sansSerif}

    font-weight: 800;
    font-size: 28px;
    line-height: 34px;
`;

export const Body1 = styled.span`
    ${typography.sansSerif}

    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
`;

export const Page = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px 40px 48px;
`;

// Org header from Figma "Corporate Account - Discovery".
export const OrgHeaderRow = styled.div`
    ${typography.sansSerif}
    display: flex;
    align-items: center;
    gap: 14px;
`;

export const OrgName = styled.div`
    color: ${colors.onwardNavy};
    font-size: 24px;
    font-weight: 800;
`;

export const OrgSubtitle = styled.div`
    color: #000;
    font-size: 14px;
`;
